import { render, staticRenderFns } from "./RatingQuestion.vue?vue&type=template&id=070b37c7&scoped=true&"
import script from "./RatingQuestion.vue?vue&type=script&lang=js&"
export * from "./RatingQuestion.vue?vue&type=script&lang=js&"
import style0 from "./RatingQuestion.vue?vue&type=style&index=0&id=070b37c7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "070b37c7",
  null
  
)

export default component.exports